import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import format from "date-fns/format";

import getMonth from "date-fns/getMonth";
import getYear from "date-fns/getYear";
import getDate from "date-fns/getDate";

import constants from "../../../constants";
import "./DatePicker.css";

import AppointmentIcon from "../../uiElements/icons/profileIcons/AppointmentIcons";

const CustomDatePicker = ({ value, onChange, scheduledDates }) => {
  const CustomHeader = ({ props }) => {
    return (
      <div className="custom-header">
        <span className="year">
          {constants.MONTHS[getMonth(props.date)]} {getYear(props.date)}
        </span>
        <div className="float-right">
          <button
            className="navigation-button"
            onClick={props.decreaseMonth}
            disabled={props.prevMonthButtonDisabled}
          >
            {<AppointmentIcon type="leftArrow" />}
          </button>
          <button
            className="navigation-button"
            onClick={props.increaseMonth}
            disabled={props.nextMonthButtonDisabled}
          >
            {<AppointmentIcon type="rightArrow" />}
          </button>
        </div>
      </div>
    );
  };

  const renderDayContents = (day, date) => {
    return (
      <>
        <span className="custom-date">{getDate(date)}</span>

        {scheduledDates?.includes(format(date, "yyyy-MM-dd")) && (
          <p className="is-scheduled mb-0" />
        )}
      </>
    );
  };

  return (
    <div className="datePickerContainer">
      <DatePicker
        selected={value || new Date()}
        onChange={date => onChange(date)}
        renderCustomHeader={props => <CustomHeader props={props} />}
        renderDayContents={renderDayContents}
        // minDate={new Date()}
        inline
        disabledKeyboardNavigation
      />
    </div>
  );
};

export default CustomDatePicker;
